/**
 * Returns the base URL for agentic themis API calls.
 * In development builds, returns empty string so requests go through
 * the rspack dev server proxy.
 * In production/staging builds, returns the provided URL.
 *
 * Uses build-time NODE_ENV check (replaced by DefinePlugin) - cannot be
 * spoofed at runtime and gets dead-code eliminated in production builds.
 */
export const getAgenticBaseUrl = (url) => {
  // eslint-disable-next-line no-undef
  if (NODE_ENV === 'development') {
    return ''
  }
  return url
}
